import globalActionTypes from "./global.type";

// Get saved theme from localStorage or default to 'light'
const getSavedTheme = () => {
  try {
    const savedTheme = localStorage.getItem("appTheme");
    return savedTheme === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

const initState = {
  loading: false,
  loadingMini: false,
  theme: getSavedTheme(),
  error: {},
  message: {},
};

const globalReducer = (state = initState, action) => {
  switch (action.type) {
    case globalActionTypes.LOADER_REMOVE:
      return {
        ...state,
        loading: action.payload,
      };

    case globalActionTypes.LOADER_MINI_REMOVE:
      return {
        ...state,
        loadingMini: action.payload,
      };
    case globalActionTypes.TOGGLE_THEME: {
      const newTheme = state.theme === "light" ? "dark" : "light";
      try {
        localStorage.setItem("appTheme", newTheme);
      } catch {
        // Ignore localStorage errors
      }
      return {
        ...state,
        theme: newTheme,
      };
    }

    case globalActionTypes.LOADER_START:
      return {
        ...state,
        loading: action.payload,
      };

    case globalActionTypes.LOADER_MINI_START:
      return {
        ...state,
        loadingMini: action.payload,
      };
    case globalActionTypes.ERROR:
      return {
        ...state,
        error: { ...state.error, [action.errorType]: action.payload },
      };

    case globalActionTypes.MESSAGE:
      return {
        ...state,
        message: { ...state.message, [action.messageType]: action.payload },
      };

    case globalActionTypes.CLEAR_GLOBAL_STATE:
      return {
        ...state,
        loading: false,
        loaderMini: false,
        error: {},
        message: {},
      };

    default:
      return state;
  }
};

export default globalReducer;
